module.exports = __webpack_public_path__ + "img/acypi-06.53f8d6d4.jpg";